import { combineReducers } from 'redux'
import { SettingStatistical } from 'src/redux/docbase/action_types'

function ui(state = [], action) {
  switch (action.type) {
    case SettingStatistical.GET_STATISTICS_REQUEST_SUCCESS:
      return action.data?.data
    default:
      return state
  }
}
export default combineReducers({ ui })
